import React, { useState, useEffect, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useInView } from "react-intersection-observer";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Whatsapp from "./Whatsapp";
import downloads from "../../components/img/downloads.png";
import "../css/VedPuramPhase.css"; // Keep this for base layout

const ProjectDetail = () => {
  const { slug } = useParams();
  const location = useLocation();

  const [project, setProject] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const formRef = useRef();
  const { ref: viewRef, inView: formInView } = useInView({ triggerOnce: true });

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset
  } = useForm();

  const queryParams = new URLSearchParams(location.search);
  const projectId = queryParams.get("project_id");
  const categoryId = queryParams.get("category_id");

  useEffect(() => {
    const fetchProject = async () => {
      if (!projectId || !categoryId) {
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(`https://adinathbuilder.com/admin/api/projects?category_id=${categoryId}`);
        const data = await res.json();

        if (data.status && Array.isArray(data.data)) {
          const matched = data.data.find((p) => String(p.id) === projectId);
          if (matched) {
            setProject(matched);

            const galleryRes = await fetch(
              `https://adinathbuilder.com/admin/api/projects/gallery?project_id=${projectId}`
            );
            const galleryData = await galleryRes.json();
            if (galleryData.status && Array.isArray(galleryData.gallery)) {
              setGallery(galleryData.gallery);
            }
          }
        }
      } catch (err) {
        console.error("Error fetching project:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [projectId, categoryId]);

  const onSubmit = async (formData) => {
    try {
      await fetch("https://adinathbuilder.com/admin/api/enquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          project_name: project?.name || "Adinath Project"
        }),
      });
      setSubmitted(true);
      reset();
      setTimeout(() => setSubmitted(false), 3000);
    } catch (err) {
      console.error("Error submitting enquiry:", err);
    }
  };

  const showNextImage = () => {
    setSelectedImageIndex((selectedImageIndex + 1) % gallery.length);
  };

  const showPreviousImage = () => {
    setSelectedImageIndex(
      (selectedImageIndex - 1 + gallery.length) % gallery.length
    );
  };

  if (loading) return <div className="text-center mt-5">Loading...</div>;
  if (!project) return <div className="text-center text-danger mt-5">Project not found</div>;

  return (
    <div className="tour-details-container">
      <Navbar />

      {/* Banner */}
      <div id="projectCarousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {project.gallery_urls && project.gallery_urls.map((img, index) => (
            <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
              <img
                src={img}
                className="d-block w-100 carousel-image"
                alt={`${project.name} - ${index}`}
              />
              <div className="overlayy"></div>
            </div>
          ))}
        </div>

        {/* Custom Carousel Controls */}
<button
  className="custom-carousel-btn prev"
  type="button"
  data-bs-target="#projectCarousel"
  data-bs-slide="prev"
>
<span className="carousel-control-prev-icon" aria-hidden="true"></span>
</button>

<button
  className="custom-carousel-btn next"
  type="button"
  data-bs-target="#projectCarousel"
  data-bs-slide="next"
>
<span className="carousel-control-next-icon" aria-hidden="true"></span>
</button>

{/* CSS */}
<style jsx>{`
  .custom-carousel-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: rgba(0,0,0,0.5);
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    font-size: 1.5rem;
  }

  .custom-carousel-btn:hover {
    background: #7CA24A;
    color: #fff;
    transform: translateY(-50%) scale(1.1);
    box-shadow: 0 4px 15px rgba(0,0,0,0.3);
  }

  .custom-carousel-btn.prev {
    left: 20px;
  }

  .custom-carousel-btn.next {
    right: 20px;
  }
`}</style>
      </div>


      {/* Title & Brochure */}
      <div className="tour-details">
        <h2 className="tour-title text-white">{project.name}</h2>
        <div className="tour-info-container">
          <div className="tour-info">
            <div className="info-item">
              <span className="icon">
                <div className="download-container">

                  <a
                    href={
                      project.brochure
                        ? `https://adinathbuilder.com/admin/public/${project.brochure}`
                        : ""
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bounce-effect"
                  >

                    <img src={downloads} alt="Download" width="45" height="45" />
                  </a>
                </div>
              </span>
              <span className="label text-white">
                Brochure <br />
                <span style={{ color: "grey" }}>Click for Download</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Star Rating */}
      <div>
        <p className="text-start texp ms-4">
          Top Rated |
          <i className="fa fa-star ms-1" style={{ color: "gold" }}></i>
          <i className="fa fa-star ms-1" style={{ color: "gold" }}></i>
          <i className="fa fa-star ms-1" style={{ color: "gold" }}></i>
          <i className="fa fa-star ms-1" style={{ color: "gold" }}></i>
          <i className="fa fa-star ms-1" style={{ color: "gold" }}></i>
        </p>
      </div>
      <hr />

      {/* Overview + Contact Form */}
      <div className="overview-contact-wrapper">
        <div className="overview-container">
          <h1 className="overvieyw-title text-start ms-3">Overview</h1>
          <br />
          <p className="overview-text text-start ms-3">{project.overview}</p>
        </div>

        <div className="contact-form-wrapper">
          <div className="form-wrapper">
            <div className="form-section">
              {submitted ? (
                <div className="success-message animate__animated animate__fadeIn">
                  <p>Thank you for your message! We will get back to you soon.</p>
                </div>
              ) : (
                <form
                  ref={formRef}
                  className={`contact-form ${formInView ? "fade-in" : ""}`}
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <h6 className="text-start">Book Your 🏡 HOME/PLOT</h6>
                  <br />
                  {["name", "email", "contact", "address", "pincode", "message"].map((field, i) => (
                    <div className="input-group" key={i}>
                      {field === "message" ? (
                        <textarea
                          placeholder="Message"
                          {...register(field, { required: `${field} is required` })}
                        />
                      ) : (
                        <input
                          placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                          type={field === "email" ? "email" : "text"}
                          {...register(field, {
                            required: `${field} is required`,
                            ...(field === "contact" && {
                              pattern: {
                                value: /^[0-9]{10}$/,
                                message: "Enter a valid 10-digit phone number",
                              },
                            }),
                            ...(field === "pincode" && {
                              pattern: {
                                value: /^[0-9]{6}$/,
                                message: "Enter a valid 6-digit pin code",
                              },
                            }),
                          })}
                        />
                      )}
                      {errors[field] && <p className="error-message">{errors[field].message}</p>}
                    </div>
                  ))}
                  <button type="submit" className="submit-btn" disabled={isSubmitting}>
                    {isSubmitting ? <span className="loading-spinner"></span> : "SEND A MESSAGE"}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Gallery */}
      <div className="gallery-container">
        <br />
        <div className="gallery-grid">
          {gallery.map((image, index) => (
            <div
              key={image.id}
              className="gallery-item"
              onClick={() => setSelectedImageIndex(index)}
            >
              <img
                src={`https://adinathbuilder.com/admin/public/${image.image_path}`}
                alt={`Gallery ${index + 1}`}
              />
            </div>
          ))}
        </div>

        {selectedImageIndex !== null && (
          <div className="image-viewer">
            <span className="close" onClick={() => setSelectedImageIndex(null)}>
              ×
            </span>
            <button className="prev-btn" onClick={showPreviousImage}>
              &lt;
            </button>
            <img
              className="viewer-image"
              src={`https://adinathbuilder.com/admin/public/${gallery[selectedImageIndex].image_path}`}
              alt="Selected"
            />
            <button className="next-btn" onClick={showNextImage}>
              &gt;
            </button>
          </div>
        )}
      </div>

      {/* Map Section */}
      <div
        className="map-container"
        dangerouslySetInnerHTML={{ __html: project?.location }}
      ></div>

      <Whatsapp />
      <Footer />
    </div>
  );
};

export default ProjectDetail;
